(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: window.Shopify?.currency?.active || 'DKK' }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toFixed(2)} kr.`;
    }
  };

  window.Vandkaer = { qs, qsa, formatMoney };

  const rewriteNavLinks = (root = document) => {
    const nav = window.VK_NAV;
    if (!nav?.resolveHref) return;
    qsa('a[href]', root).forEach((link) => {
      const href = link.getAttribute('href');
      const next = nav.resolveHref(href);
      if (next && next !== href) link.setAttribute('href', next);
    });
  };
  rewriteNavLinks();
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;
    const href = link.getAttribute('href');
    const next = window.VK_NAV?.resolveHref(href);
    if (!next || next === href) return;
    event.preventDefault();
    window.location.assign(next);
  });

  const toggleDrawer = (id, open) => {
    const drawer = qs(`[data-drawer="${id}"]`);
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };

  qsa('[data-open-drawer]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      toggleDrawer(btn.dataset.openDrawer, true);
    });
  });
  qsa('[data-close-drawer]').forEach((btn) => {
    btn.addEventListener('click', () => toggleDrawer(btn.dataset.closeDrawer, false));
  });
  qsa('.drawer__overlay').forEach((el) => {
    el.addEventListener('click', () => el.closest('.drawer')?.classList.remove('is-open'));
  });

  qsa('[data-submenu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.closest('li')?.classList.toggle('is-open');
    });
  });

  const searchModal = qs('[data-search-modal]');
  qsa('[data-open-search]').forEach((btn) => {
    btn.addEventListener('click', () => searchModal?.classList.add('is-open'));
  });
  qsa('[data-close-search]').forEach((btn) => {
    btn.addEventListener('click', () => searchModal?.classList.remove('is-open'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      qsa('.drawer.is-open, .search-modal.is-open').forEach((el) => el.classList.remove('is-open'));
      document.body.style.overflow = '';
    }
  });

  const updateCartCount = (count) => {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  };

  const renderCartDrawer = async () => {
    const drawer = qs('[data-cart-items]');
    if (!drawer) return;
    const cart = await fetch('/cart.js').then((r) => r.json());
    updateCartCount(cart.item_count);
    if (!cart.items.length) {
      drawer.innerHTML = `<div class="empty-state"><h3 class="h3">Kurven er tom</h3><p>Gå på opdagelse blandt vores elcykler.</p><a class="btn" href="${window.VK_NAV?.catalogUrl || '/collections/elcykler'}">Se elcykler</a></div>`;
      const emptyFooter = qs('[data-cart-footer]');
      if (emptyFooter) emptyFooter.hidden = true;
      return;
    }
    const footer = qs('[data-cart-footer]');
    if (footer) footer.hidden = false;
    drawer.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-key="${item.key}">
        <img src="${item.image || ''}" alt="${item.title}" width="80" height="80">
        <div>
          <a href="${item.url}">${item.product_title}</a>
          <div class="qty">
            <button type="button" data-qty="-1" aria-label="Mindsk">−</button>
            <input value="${item.quantity}" readonly>
            <button type="button" data-qty="1" aria-label="Øg">+</button>
          </div>
        </div>
        <strong>${formatMoney(item.final_line_price)}</strong>
      </div>
    `).join('');
    const total = qs('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    rewriteNavLinks(drawer);
  };

  document.addEventListener('click', async (event) => {
    const qtyBtn = event.target.closest('[data-qty]');
    if (!qtyBtn) return;
    const item = qtyBtn.closest('[data-key]');
    if (!item) return;
    const input = item.querySelector('input');
    const next = Math.max(0, Number(input.value) + Number(qtyBtn.dataset.qty));
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.dataset.key, quantity: next })
    });
    renderCartDrawer();
    document.dispatchEvent(new CustomEvent('cart:updated'));
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.classList.add('is-disabled');
    const data = new FormData(form);
    const response = await fetch('/cart/add.js', { method: 'POST', body: data });
    if (submit) submit.classList.remove('is-disabled');
    if (!response.ok) {
      form.querySelector('[data-form-error]')?.removeAttribute('hidden');
      return;
    }
    await renderCartDrawer();
    toggleDrawer('cart', true);
  });

  renderCartDrawer();

  const searchInput = qs('[data-predictive-search]');
  const searchResults = qs('[data-predictive-results]');
  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(async () => {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=5`);
      const json = await res.json();
      const products = json.resources?.results?.products || [];
      const pages = json.resources?.results?.pages || [];
      const articles = json.resources?.results?.articles || [];
      if (!products.length && !pages.length && !articles.length) {
        const safe = q.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
        searchResults.innerHTML = `<p>Ingen resultater for “${safe}”.</p>`;
        return;
      }
      searchResults.innerHTML = [
        ...products.map((p) => `<a href="${p.url}">${p.title}</a>`),
        ...pages.map((p) => `<a href="${p.url}">${p.title}</a>`),
        ...articles.map((p) => `<a href="${p.url}">${p.title}</a>`)
      ].join('');
    }, 180);
  });

  const liftChat = () => {
    if (window.matchMedia('(min-width: 990px)').matches) return;
    const offset = 'calc(8.75rem + env(safe-area-inset-bottom, 0px))';
    document.querySelectorAll('#dummy-chat-button-iframe, #shopify-chat, #shopify-chat > iframe, inbox-online-store-chat, iframe#ShopifyChat').forEach((el) => {
      const style = (el.getAttribute('style') || '').toLowerCase();
      const isOpen = el.getAttribute('isopen') === 'true' || style.includes('min-height') || style.includes('left: 0');
      el.style.setProperty('bottom', isOpen ? '0px' : offset, 'important');
    });
  };
  liftChat();
  new MutationObserver(liftChat).observe(document.documentElement, { childList: true, subtree: true });
})();
